import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {SmartDropdownCellEditorComponent} from '@shared/components/cell-editors/smart-dropdown-cell-editor/smart-dropdown-cell-editor.component';
import {FormBuilder} from '@angular/forms';
import {Store} from '@ngrx/store';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import { DialogService } from '@shared/services/dialog-service';

@Component({
    standalone: false,
    selector: 'particle-reporting-entity-dependant-smart-dropdown-cell-editor',
  templateUrl: './reporting-entity-dependant-smart-dropdown-cell-editor.component.html',
  styleUrls: ['./reporting-entity-dependant-smart-dropdown-cell-editor.component.scss']
})
export class ReportingEntityDependantSmartDropdownCellEditorComponent extends SmartDropdownCellEditorComponent implements OnInit {

  constructor(protected formBuilder: FormBuilder,
              protected particleStore: Store<ParticleState>,
              protected changeDetectorRef: ChangeDetectorRef,
              protected dialogService: DialogService) { //realease beafore work dont slang me for this service injection
    super(formBuilder, particleStore, changeDetectorRef,dialogService);
  }

  ngOnInit() {
    super.ngOnInit();

    const ReportingEntity = 'ReportingEntity';
    const RelevantTaxpayerNexus = 'RelevantTaxpayerNexus';
    const RelevantTaxpayerCapacity = 'RelevantTaxpayerCapacity';
    const IntermediariesNexus = 'IntermediariesNexus';
    const IntermediariesCapacity = 'IntermediariesCapacity';
    const fieldDefinitionKey = this.fieldDefinition.key;


    if (this.item.cells[ReportingEntity] && this.item.cells[ReportingEntity].value) {
      const isIntermediary = this.item.cells[ReportingEntity].value.isIntermediary;
      if (isIntermediary && (fieldDefinitionKey === RelevantTaxpayerNexus || fieldDefinitionKey === RelevantTaxpayerCapacity)) {
        this.disabled = true;
      }

      if (!isIntermediary && (fieldDefinitionKey === IntermediariesNexus || fieldDefinitionKey === IntermediariesCapacity)) {
        this.disabled = true;
      }
    }
  }
}
